<template>
    <div class="p-4">
        <l-container class="mb-4">
            <l-container-title slot="toolbar" text="Grupper" icon="user-tag" color="bg-black" />
            <l-info-box class="mb-4" :active="groups.length > 0">Rightclick on a row to edit or delete</l-info-box>
            <div class="flex w-full justify-between">
                <div v-if="!showAddGroupPanel">
                    <l-button type="success" @click="showAddGroupPanel = true">
                        <font-awesome-icon icon="user-tag" class="text-xl text-white" />
                        New group
                    </l-button>
                </div>
                <div v-if="showAddGroupPanel" class="rounded border w-full">
                    <div class="m-2 container">
                        <div class="w-full float-left">
                            <div class="w-64">
                                <b>Name</b>
                                <br />
                                <l-input placeholder="Navn" v-model="newObj.name" inputClass="text-2xs" />
                            </div>
                            <div class="w-full flex mb-4"></div>
                            <div class="w-full flex mb-4">

                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Network</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="newObj.network">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Observations</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="newObj.observations">Read/Write</l-checkbox>
                    </div>
                </div>                
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Export</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="newObj.exporting">Read/Write</l-checkbox>
                    </div>
                </div>
            </div>
            <div class="w-full flex mb-4">

                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Quality control</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="newObj.qualitycontrol">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Processing</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="newObj.processing">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Users</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="newObj.users">Read/Write</l-checkbox>
                    </div>
                </div>
            </div>
            <div class="w-full flex mb-4">
                <div class="w-full">
                    <b>Networks</b>&nbsp;
                    <br />
                    <l-checkbox class="mr-4" v-model="newObj.allnetworks">All networks</l-checkbox>
                    <br />
                    <l-select2 v-if="!newObj.allnetworks" v-model="newObj.networkIds" placeholder="Choose networks" :multiple="true" :options="networkSelectionList" :clearable="false" />

                </div>
            </div>
                            <div class="w-full flex mb-4">
                                <div class="w-full">
                                    <b>Users</b>&nbsp;
                                    <br />
                                    <l-select2 v-model="newObj.userIds" placeholder="Velg bruker(e)" :multiple="true" :options="userSelectionList" :clearable="false" />

                                </div>
                            </div>
                            <div class="w-full p-3 clearfix">
                            </div>
                            <div class="w-full">
                                <l-button type="success"
                                          :disabled="newObj.name==''"
                                          :title="(newObj.name=='')? 'Name is required' : ''"
                                          @click="onAddGroupSave">Save</l-button>
                                <l-button type="danger" @click="onAddGroupClose">Close</l-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex w-full justify-between">
            </div><br />
            <hot-table :data="groups" :settings="settings" ref="hot">
                <hot-column title="Name" data="name" read-only="true"></hot-column>
            </hot-table>
        </l-container>
        <GroupEdit :showing="edit" @close="edit = false" :selectedGroup="selectedGroup" @save="onGroupUpdated" :selectedNetworks="selectedNetworks" :selectedUsers="selectedUsers"></GroupEdit>

    </div>
</template>

<script>
    //import * as moment from "moment";
    import { LInput, LButton, LSelect2, LBadge, LCheckbox } from "@/components/forms";
    import Notify from "@/helpers/notify";
    import HandsontableHelper from "@/helpers/settings/handsontable";
    import "handsontable/dist/handsontable.full.css";
    import { HotTable, HotColumn } from "@handsontable/vue";
    import Handsontable from "handsontable";
    import LInfoBox from "@/components/LInfoBox";
    import GroupService from "./group.service";
    import GroupEdit from "./GroupEdit";
    import ContextMenu from "./context.menu";

    export default {
        name: "Groups",
        components: {
            HotTable,
            HotColumn,
            LInput,
            LButton,
            LInfoBox,
            LSelect2,
            LBadge,
            GroupEdit,
            LCheckbox
        },

        data() {
            return {
                edit: false,
                groups: [],
                settings: HandsontableHelper.settings(false),
                showAddGroupPanel: false,
                passwordFieldType: 'password',
                users: [],
                selectedUsers: [],
                networkSelectionList: [],
                userSelectionList: [],
                selectedGroup: {},
                selectedNetworks: [],
                newObj: {
                    name: '',
                    network: false,
                    observations: false,
                    exporting: false,
                    processing: false,
                    qualitycontrol: false,
                    users: false,
                    allnetworks: false,
                    networkIds: [],
                    userIds: [],

                },
                newObjTempl: {
                    name: '',
                    network: false,
                    observations: false,
                    exporting: false,
                    processing: false,
                    qualitycontrol: false,
                    users: false,
                    allnetworks: false,
                    networkIds: [],
                    userIds: [],
                },
            };
        },

        mounted() {
            Notify.loadData(null, this.loadInitialData);
            this.settings.contextMenu = ContextMenu(this);
        },
        watch: {
        },
        methods: {
            async loadInitialData() {
                this.groups = await GroupService.groups();
                this.networkSelectionList = await GroupService.networkSelectList();
                this.userSelectionList = await GroupService.users();
            },
            async onAddGroupSave() {
                await Notify.loadData("Saving '" + this.newObj.name + "'", this.saveGroup, JSON.parse(JSON.stringify(this.newObj))); //, JSON.parse(JSON.stringify(this.selectedUsers))
                this.newObj.name = '';
                Notify.loadData(null, this.loadInitialData);
            },
            onDeleteGroup(t, o) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);
                Notify.prompt(async response => {
                    if (response) {
                        await Notify.loadData("Deleting group...", async () => {
                            const rowsAffected = await GroupService.deleteGroup(row.id);
                            this.loadInitialData;
                            const activeEditor = hot.getActiveEditor();
                            hot.alter("remove_row", clickedRow, 1);
                            Notify.success("Group deleted");
                        });
                    }
                }, "Are you sure you want to delete this group?");
            },
            async onEditGroup(t, o) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);
                this.selectedGroup = row;
                this.edit = true;
                this.selectedNetworks = await GroupService.groupNetworkSelectList(row.id);
                this.selectedUsers = await GroupService.groupUsersSelectList(row.id);
            },
            async saveGroup(group) {
                await GroupService.addGroup(group);
            },
            async onAddGroupClose() {

                this.newObj = this.newObjTempl;
                this.showAddGroupPanel = false;

            },
            switchVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            },
            removeGroup(val) {
                this.selectedgroups.splice(this.selectedgroups.indexOf(val), 1);
            },
            closeNewGroupModal() {
                this.showAddGroupModal = false;
            },
            async onGroupUpdated() {                
                Notify.loadData(null, this.loadInitialData);                
            }

        }
    };
</script>
<style>
    .file-uploads {
        background: #efefef;
        height: 100px;
        vertical-align: middle;
    }

        .file-uploads span {
            position: relative;
            top: 40px;
            vertical-align: middle;
        }
</style>